import { render, staticRenderFns } from "./MoleculeContentBlockImage.vue?vue&type=template&id=66f952ad&"
import script from "./MoleculeContentBlockImage.vue?vue&type=script&lang=js&"
export * from "./MoleculeContentBlockImage.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeContentBlockImage.vue?vue&type=style&index=0&id=66f952ad&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports